<template>
  <div>
  <div class="row">
    <div class="col-12 col-md-8">
      <h1 class="display-4" id="title">Avis à traiter</h1>
      <nav class="breadcrumb-container d-inline-block" aria-label="breadcrumb">
        <ul class="breadcrumb pt-0">
          <li class="breadcrumb-item">
            <a href="#" @click="$emit('goto_review_list')">{{establishment.name}}</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#" @click="$emit('goto_review_list')">Liste des avis à traiter</a>
          </li>
          <li class="breadcrumb-item">
            Avis à traiter
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-xl-4">
      <div class="card mb-5">
        <div class="card-body">
          <div class="row mb-4">

            <div class="col-4">
              <div class="position-relative">
                  <div style="height:80px;width:80px;background-size:contain;background-repeat:no-repeat;background-position:center center;;"
                       :style="{'background-image':'url('+settings.backendMediaUrl+review.platform.logo2+')'}"></div>
              </div>
            </div>
            <div class="col-8">
              <div class="mb-2">
                <div class="text-primary cta-4">{{review.mark}} <small> / 10</small></div>
              </div>
              <div class="heading mb-0">
                  <a :href="review.author_url" v-if="review.author_url">
                      {{review.author}}
                  </a>
                  <span v-else>
                      {{review.author}}
                  </span>
              </div>
              <div class="text-muted text-medium mb-2">
                  {{review.published_on|human_date}}
              </div>
              <div>
                  <span v-if="review.has_answer">
                    <i class="fa fa-comment-dots"></i>
                    <span> &nbsp;Présence d'une réponse&nbsp;&nbsp;</span>
                    <br>
                  </span>
                  <span v-if="review.photo">
                    <i class="fa fa-image"></i>
                    <span> &nbsp;Présence de photo&nbsp;&nbsp;</span>
                    <br>
                  </span>
                  <span v-if="review.typo_client">
                    <i class="fa fa-users"></i>
                    &nbsp;{{review.typo_client}}&nbsp;&nbsp;
                  </span>

              </div>
            </div>
          </div>

          <div class="name mb-2">
              <img src="/img/profile/flag-french.png" width="18px" height="18px" style="margin-right:10px;"></img>
              <!--<MyFlag :lang="review.native_lang.code.toLowerCase()" style="margin-top:0px;" />-->
              {{review.title_fr}}
          </div>
          
          <div class="mb-3 text-alternate">
            <div class="scroll-out msh-20">
              <div class="scroll msh-20">
                <pre style="color:rgb(124, 124, 124);">{{review.text_fr}}</pre>
              </div>
            </div>
          </div>
        
          <a href="#"
             v-if="review.text_native != ''"
             class="mb-3 d-flex align-items-center"
             data-bs-toggle="collapse"
             data-bs-target="#collapseEN"
             aria-expanded="true"
             aria-controls="collapseEN">
            <MyFlag :lang="review.native_lang.code.toLowerCase()"/>
            Voir l'avis original
          </a>
          <div class="collapse" id="collapseEN">
            <div class="name mb-2">{{review.title_native}}</div>
            <div class="mb-3 text-alternate">
              <div class="scroll-out msh-20">
                <div class="scroll msh-20">
                  <pre style="color:rgb(124, 124, 124);">{{review.text_native}}</pre>
                </div>
              </div>
            </div>
          </div>

          <div>
              Date de séjour : {{review.journey_date || 'inconnue'}}<br>
              Présence visuel : {{review.photo ? 'oui' : 'non'  }}<br>
              Type hébergement : {{review.establishment_scrap_url_type ? review.establishment_scrap_url_type.name : 'inconnu'}}<br>
              <br>
          </div>
          
          <a v-if="review.link_on_platform != ''"
             :href="review.link_on_platform"
             class="btn btn-outline-primary mb-1 d-block"
             target="_blank">
              Voir l'avis en ligne
          </a>          
          <a v-if="review.link_on_platform == '' && conn_info != null"
             :href="conn_info.establishment_link"
             class="btn btn-outline-primary mb-1 d-block"
             target="_blank">
              Voir l'avis en ligne
          </a>          
        </div>
        
      </div>
      <VotreConsultant :consultant="establishment.consultant"></VotreConsultant>
    </div>

    
    <div class="col-12 col-xl-8">

      <div> <!--{{'EstablishmentState'+review.current_state.class_name}}-->
        <keep-alive>
          <component v-if="detailedReview"
                     :is="'EstablishmentState'+review.current_state.class_name"
                     :review="detailedReview"
                     :state="detailedReview.current_state"
                     :establishment="establishment"
                     :text_role="text_role"
                     v-on:state-updated="stateUpdated()"
                     v-on:goto_review_list="$emit('goto_review_list')"></component>
        </keep-alive>
      </div>
    </div>
  </div>
  </div>
</template>


<script>
import REVIEW_DETAIL_FOR_ESTABLISHMENT from '@/gql/queries/reviewDetailForEstablishment.graphql';
import CONNECTION_FOR from '@/gql/queries/connectionFor.graphql';
import { gqlQuery } from '@/gqlClient.js';
import VotreConsultant from '@/components/VotreConsultant';
import settings from '@/settings.coffee';
import MyFlag from "@/components/MyFlag.vue";
import EstablishmentStateInformationNeeded from "@/components/review_states/EstablishmentStateInformationNeeded.vue";
import EstablishmentStateAnswerWriting from "@/components/review_states/EstablishmentStateAnswerWriting.vue";
import EstablishmentStateAnswerTextValidation from "@/components/review_states/EstablishmentStateAnswerTextValidation.vue";
import EstablishmentStateSignalingWriting from '@/components/review_states/EstablishmentStateSignalingWriting';
import EstablishmentStateSignalingSent from '@/components/review_states/EstablishmentStateSignalingSent';
import EstablishmentStateClassified from '@/components/review_states/EstablishmentStateClassified';
import EstablishmentStateAnswerPublished from '@/components/review_states/EstablishmentStateAnswerPublished.vue';
import EstablishmentStateAnswerAccepted from '@/components/review_states/EstablishmentStateAnswerAccepted';
import EstablishmentStateWaitingForInformation from '@/components/review_states/EstablishmentStateWaitingForInformation';

export default {
  name: "GatheringReviewDetail",
  components: {
    MyFlag,
    VotreConsultant,
    EstablishmentStateInformationNeeded,
    EstablishmentStateWaitingForInformation,
    EstablishmentStateAnswerWriting,
    EstablishmentStateAnswerTextValidation,
    EstablishmentStateSignalingWriting,
    EstablishmentStateSignalingSent,
    EstablishmentStateClassified,
    EstablishmentStateAnswerPublished,
    EstablishmentStateAnswerAccepted
  },
  data() {
    return {
      detailedReview: null,
      conn_info: null
    };
  },
  props: {
    establishment: Object,
    review: Object,
    text_role: {
      default: null
    }
  },
  computed: {
    settings() {
      return settings;
    }
  },
  methods: {
    async stateUpdated() {
      const response = await gqlQuery(REVIEW_DETAIL_FOR_ESTABLISHMENT, { uid: this.$route.params.review_uid });
      console.log("stateUpdated", response.body.data.review);
      if (response.ok) {
        this.detailedReview = response.body.data.review;
      }
    }
  },
  async mounted() {
    const response = await gqlQuery(REVIEW_DETAIL_FOR_ESTABLISHMENT, { uid: this.$route.params.review_uid });
    if (response.ok) {
      this.detailedReview = response.body.data.review;
      gqlQuery(CONNECTION_FOR, { platform_uid: this.detailedReview.platform.uid, establishment_uid: this.detailedReview.establishment.uid }).then((resp) => {
        if (resp.body.data.connection_set.length > 0) {
          this.conn_info = resp.body.data.connection_set[0];
        } else {
          this.conn_info = null;
        }
      });
    }
  }
};
</script>


<style>
  .breadcrumb-item{
  font-size:0.85em;
  }
  .card-header{
      display:block;
  }
  .mytitle{
      font-size:23px;
      margin-bottom:10px;
  }
  .scroll{
      overflow-y: auto;
  }
</style>
